import $ from 'jquery';

/**
 * Enables automatic tracking on links and forms.
 *
 * @param context
 */
export default function trackingEnhancement(context=document.body) {
	const $context = $(context);

	const trackingElements = [
		{ selector: 'a[href^="mailto:"]', label: "Email click" },
		{ selector: 'a[href^="tel:"]', label: "Phone click" },
		{ selector: 'form', label: "Form sent" },
	];

	trackingElements.forEach(({ selector, label }) => {
		$context.find(selector).attr('sw-tracker', JSON.stringify({ label }))
	});
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/tracking.js